<template>
  <div>
    <logout-header v-if="error" />
    <div id="splash">
      <fetch-error
        @retry="fetchData()"
        v-if="error"
        :error="error"
      ></fetch-error>
      <loader v-else></loader>
    </div>
  </div>
</template>

<script>
import authService from "../services/AuthService";
import FetchError from "../services/api/FetchError";
import LogoutHeader from "../layouts/components/LogoutHeader.vue";

export default {
  components: { LogoutHeader },
  name: "PreLoader",
  data() {
    return { FetchError };
  },
  computed: {
    error() {
      const { myProfile, managedProviders } = this.$store.state.profile;

      return myProfile.error || managedProviders.error;
    },
  },
  methods: {
    fetchData() {
      if (authService.id) {
        this.$store.dispatch("profile/FETCH_MY_PROFILE");
        this.$store.dispatch("profile/FETCH_MANAGED_PROVIDERS");
      } else {
        this.$store.dispatch("profile/FETCH_MY_PROFILE", () => {
          this.$store.dispatch("profile/FETCH_MANAGED_PROVIDERS");
        });
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
#splash {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
